// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateCardNumber(cardNumber: string): ?UserInputValidationError {
  if (!cardNumber || !cardNumber.trim()) {
    return { id: 'empty' };
  }
  
  if (!validCardLength(cardNumber)) {
    return { id: 'invalid-pattern' };
  }

  if(!luhnAlgCheck(cardNumber) && !luhnAlgCheckForNaranja(cardNumber)) {
    return { id: 'invalid-value' };
  }
}

function validCardLength(number: string): boolean {
  return /^\d{12,19}$/.test(number);
}

function luhnAlgCheck(number: string): boolean {
  let b;
  let c;
  let d;
  let e;

  for (d = +number[b = number.length - 1], e = 0; b--;) {
    c = +number[b], d += ++e % 2 ? 2 * c % 10 + (c > 4) : c;
  }

  return (d % 10) === 0;
}

function luhnAlgCheckForNaranja(number: string): boolean {
  const total =
    +number[0] * 4 +
    +number[1] * 3 +
    +number[2] * 2 +
    +number[3] * 7 +
    +number[4] * 6 +
    +number[5] * 5 +
    +number[6] * 4 +
    +number[7] * 3 +
    +number[8] * 2 +
    +number[9] * 7 +
    +number[10] * 6 +
    +number[11] * 5 +
    +number[12] * 4 +
    +number[13] * 3 +
    +number[14] * 2;

  const digit = 11 - (total % 11);

  if (digit > 9) {
    return +number[15] === 0;
  }

  return +number[15] === digit;

}
